import React from "react";

export default function Blog() {
  return (
    <div>
      <section className="client_section layout_padding-bottom">
        <div className="container">
          <div className="heading_container heading_center">
            <h2>What Our Customers Say</h2>
          </div>
          <div className="col-md-9 col-lg-7 mx-auto px-0">
            <div className="box">
              <div className="b-1">
                <div className="client_id">
                  <div className="img-box">
                    <img
                      src={process.env.REACT_APP_IMG_BASE_URL + "luis-suarez.jpg"}
                      alt="blog-img1"
                    />
                  </div>
                  <div className="name">
                    <h5>Luis Suárez</h5>
                    <h6>Soccer Player</h6>
                  </div>
                </div>
              </div>
              <div className="client_detail">
                <p>
                  SUPERPOWER is my go-to shop for dietary supplements. It's an independent
                  organization filled with good people, who can provide advice for anyone taking
                  supplements.
                </p>
              </div>
            </div>
            <div className="box">
              <div className="client_id">
                <div className="img-box">
                  <img
                    src={process.env.REACT_APP_IMG_BASE_URL + "danielle-sidell.jpg"}
                    alt="blog-img2"
                  />
                </div>
                <div className="name">
                  <h5>Helen Law</h5>
                  <h6>Crossfit athlete</h6>
                </div>
              </div>
              <div className="client_detail">
                <p>
                  I believe supplements can play a very important role in health, but only if there is some
                  scientific evidence validating their claims; and these products contain what their
                  labels claim. Thanks so much for the good work you do in providing these products.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
